import ClassNameGenerator from '@mui/utils/ClassNameGenerator';

// Must run before any @mui/material module evaluates: those modules build their static class
// objects (gridClasses, buttonGroupClasses, ...) at load time, and the parent-to-child selectors
// built from them stop matching rendered elements if the prefix arrives later. This file imports
// @mui/utils alone, which vite.config.mjs splits out of the @mui/material chunk, so src/index.js
// can run it before bootstrap pulls in the rest of MUI.
ClassNameGenerator.configure(componentName => `muitrvl-${componentName}`);
